// extracted by mini-css-extract-plugin
export default {"extendedButton":"AttachFileButton_extendedButton__pE6C3","mobileButton":"AttachFileButton_mobileButton__-aGDo"};